import React, { useState } from "react";

const PhoneNumberManagement = () => {
  const [phoneNumbers, setPhoneNumbers] = useState([
    "7795076327",
    "9901855044",
  ]);
  const [newNumber, setNewNumber] = useState("");
  const [message, setMessage] = useState(null);

  const handleAddNumber = (e) => {
    e.preventDefault();
    if (newNumber.trim()) {
      setPhoneNumbers([...phoneNumbers, newNumber.trim()]);
      setMessage({ type: "success", text: "Phone number added successfully!" });
      setNewNumber("");
    } else {
      setMessage({ type: "error", text: "Please enter a valid phone number." });
    }
  };

  const handleRemoveNumber = (number) => {
    setPhoneNumbers(phoneNumbers.filter((p) => p !== number));
    setMessage({ type: "success", text: "Phone number removed successfully!" });
  };

  return (
    <div className="p-4 bg-white rounded shadow mb-6">
      <h3 className="text-xl font-bold text-blue-600 mb-2 text-left">
        Phone Number Management
      </h3>

      <form onSubmit={handleAddNumber} className="flex flex-col">
        <input
          type="text"
          value={newNumber}
          onChange={(e) => setNewNumber(e.target.value)}
          placeholder="Add new phone number"
          className="p-2 border rounded mb-2"
        />
        <button type="submit" className="bg-blue-600 text-white p-2 rounded">
          Add Phone Number
        </button>
      </form>
      {message && (
        <div
          className={`mb-4 mt-4 p-2 rounded ${
            message.type === "success"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {message.text}
        </div>
      )}
      <h4 className="mt-4 mb-4 font-semibold text-left">
        Active Phone Numbers:
      </h4>
      <ul className="mb-4">
        {phoneNumbers.map((number, index) => (
          <li key={index} className="flex justify-between items-center mb-4">
            <span>{number}</span>
            <button
              onClick={() => handleRemoveNumber(number)}
              className="text-red-600"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PhoneNumberManagement;
